module.exports = __webpack_public_path__ + "img/help-content-4.a23445bb.png";